// TSS vite/02 — centralized constants.

export const MAX_NAME_LEN = 255;
export const MAX_EMAIL_LEN = 255;
export const MAX_PHONE_LEN = 32;

export const MIN_PASSWORD_LEN = 8;

export const SEARCH_DEBOUNCE_MS = 300;

// Portal · perfil del cliente (PATCH public/me — Q-101). Límites del contrato
// public-client-channel.md: name 1..120, phone ≤40 (nullable). Distintos de los
// genéricos de arriba — acá manda el contrato del canal público.
export const PROFILE_NAME_MAX = 120;
export const PROFILE_PHONE_MAX = 40;

// Portal · fincas del cliente (public-farms.md, Q-120). name trim 1..120,
// responsible trim ≤160 (nullable).
export const FARM_NAME_MAX = 120;
export const FARM_RESPONSIBLE_MAX = 160;

// Portal · receptoras del cliente (public-recipients.md, Q-121). number trim
// 1..40 (único por finca), name trim ≤120 (nullable).
export const RECIPIENT_NUMBER_MAX = 40;
export const RECIPIENT_NAME_MAX = 120;

// Portal · propuestas de donadora (public-donor-submissions.md, Q-122).
// name ≤120, number ≤40 (arete propuesto, NO el register), appearance ≤255.
export const SUBMISSION_NAME_MAX = 120;
export const SUBMISSION_NUMBER_MAX = 40;
export const SUBMISSION_APPEARANCE_MAX = 255;
